import { MAX_REQUESTS, REQUEST_FORM_FIELDS } from "core/consts";
import {
  TransitionalCareImportedAuctionRequest,
  TransitionalCareRequest,
} from "core/types";
import {
  fromUnixTime,
  getHours,
  getMilliseconds,
  getMinutes,
  getSeconds,
} from "date-fns";
import {
  getLastId,
  toFormRequest,
} from "dsl/ecosystems/PatientForms/TransitionalCare/Form/FormSections/SectionE/RequestListContext/utils";

export function numberToRequestSentTime(value: number | null | undefined): {
  hour: number;
  millisecond: number;
  minute: number;
  second: number;
} | null {
  if (value == null || typeof value !== "number") return null;
  const date = fromUnixTime(value);
  return {
    hour: getHours(date),
    millisecond: getMilliseconds(date),
    minute: getMinutes(date),
    second: getSeconds(date),
  };
}

function isManualRequest(request: {
  manual?: boolean;
  request_id?: number | null;
}): boolean {
  return request.manual === true || request.request_id == null;
}

export function mergeRequestListWithImported(
  currentList: TransitionalCareRequest[],
  importedRequestList:
    | TransitionalCareImportedAuctionRequest[]
    | null
    | undefined,
): TransitionalCareRequest[] {
  const manualRequests = currentList
    .filter(isManualRequest)
    .map((request) => ({ ...request, manual: true }));

  const importedCount = Math.min(
    MAX_REQUESTS - manualRequests.length,
    (importedRequestList ?? []).length,
  );

  const importedRequests = (importedRequestList ?? [])
    .slice(0, importedCount)
    .map(toFormRequest(getLastId(manualRequests)));

  return normalizeRequestListForForm([...manualRequests, ...importedRequests]);
}

export function normalizeRequestListForForm(
  list: TransitionalCareRequest[] | undefined,
): TransitionalCareRequest[] {
  if (!list?.length) return list ?? [];
  return list.map((request) => {
    const time = request[REQUEST_FORM_FIELDS.REQUEST_SENT_TIME];
    const status = request[REQUEST_FORM_FIELDS.REQUEST_STATUS];
    const careproviderRequest: TransitionalCareRequest = { ...request };

    if (typeof time === "number") {
      careproviderRequest[REQUEST_FORM_FIELDS.REQUEST_SENT_TIME] =
        numberToRequestSentTime(time);
    }

    if (status != null && !Array.isArray(status)) {
      careproviderRequest[REQUEST_FORM_FIELDS.REQUEST_STATUS] = [status];
    }
    return careproviderRequest;
  });
}
